import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBlockShift(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#block_shift_svg__a)"
        strokeLinecap="round"
        strokeWidth={10}
        d="M67 29.02V14m42 15.02V14m-47 92h52c8.837 0 16-7.163 16-16V37.51c0-8.836-7.163-16-16-16H62c-8.837 0-16 7.164-16 16V90c0 8.837 7.163 16 16 16Z"
      />
      <path stroke="#0C1C43" d="M51 42.5h74" />
      <rect width={12} height={12} x={61} y={54} stroke="#0C1C43" strokeLinecap="round" rx={2} />
      <rect width={12} height={12} x={81} y={54} stroke="#0C1C43" strokeLinecap="round" rx={2} />
      <rect width={12} height={12} x={101} y={54} stroke="#0C1C43" strokeLinecap="round" rx={2} />
      <rect width={12} height={12} x={61} y={74} stroke="#0C1C43" strokeLinecap="round" rx={2} />
      <rect width={12} height={12} x={81} y={74} stroke="#0C1C43" strokeLinecap="round" rx={2} />
      <defs>
        <linearGradient
          id="block_shift_svg__a"
          x1={88}
          x2={88}
          y1={21.51}
          y2={106}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98CCFB" />
          <stop offset={1} stopColor="#E1DDDA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBlockShift);
export default ForwardRef;
